export default {"src":"/_next/static/media/wallet.1f3c44cb.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};